/**
 * dd-preorder-gate.js
 *
 * Same acceptance UX as dd-custom-gate.js (card, shake, main+sticky sync).
 * Right-side toggle accepts and expands terms. Required when window.ddPreorder.get(id)
 * is set on a buyable combo. Custom MTO wins if both somehow fire.
 */
(function () {
  'use strict';

  if (window.ddPreorderGate) return;

  var ACCEPTED_NAME = 'properties[_preorder_accepted]';
  var accepted = false;
  var wasRequired = false;
  var shakeTimer = null;
  var disclosureMs = 300;

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      return false;
    }
  }

  function syncDisclosureAria(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.classList.contains('is--open') ? 'true' : 'false');
  }

  function setDisclosureOpen(details, open) {
    if (!details) return;
    if (details._ddDisclosureTimer) {
      clearTimeout(details._ddDisclosureTimer);
      details._ddDisclosureTimer = null;
    }

    if (open) {
      details.setAttribute('open', '');
      details.classList.add('is--open');
      syncDisclosureAria(details);
      return;
    }

    details.classList.remove('is--open');
    syncDisclosureAria(details);

    var delay = prefersReducedMotion() ? 0 : disclosureMs;
    if (delay === 0) {
      details.removeAttribute('open');
      return;
    }

    details._ddDisclosureTimer = setTimeout(function () {
      details.removeAttribute('open');
      details._ddDisclosureTimer = null;
    }, delay);
  }

  function syncDisclosuresFromAccepted() {
    document.querySelectorAll('[data-dd-preorder-acceptance]').forEach(function (row) {
      if (row.hidden) {
        setDisclosureOpen(row, false);
        return;
      }
      setDisclosureOpen(row, accepted);
    });
  }

  function initDisclosures() {
    document.querySelectorAll('[data-dd-preorder-acceptance]').forEach(function (details) {
      setDisclosureOpen(details, accepted && !details.hidden);
    });
  }

  function getSwatch() {
    return document.querySelector('dd-swatch-selector');
  }

  function currentVariant() {
    var sw = getSwatch();
    if (!sw || typeof sw.getCurrentVariant !== 'function') return null;
    try {
      return sw.getCurrentVariant();
    } catch (e) {
      return null;
    }
  }

  function currentIso() {
    var v = currentVariant();
    if (!v || !window.ddPreorder || typeof window.ddPreorder.get !== 'function') return null;
    return window.ddPreorder.get(v.id);
  }

  function isRequired() {
    if (!document.querySelector('[data-dd-preorder-acceptance]')) return false;
    if (
      window.ddCustomGate &&
      typeof window.ddCustomGate.isRequired === 'function' &&
      window.ddCustomGate.isRequired()
    ) {
      return false;
    }
    var sw = getSwatch();
    if (
      sw &&
      typeof sw.isCurrentComboUnavailable === 'function' &&
      sw.isCurrentComboUnavailable()
    ) {
      return false;
    }
    var v = currentVariant();
    if (!v || v.available === false) return false;
    return !!currentIso();
  }

  function isBlocked() {
    if (!document.querySelector('[data-dd-preorder-acceptance]')) return false;
    return isRequired() && !accepted;
  }

  function atcBlocked() {
    if (isBlocked()) return true;
    if (
      window.ddCustomGate &&
      typeof window.ddCustomGate.isBlocked === 'function' &&
      window.ddCustomGate.isBlocked()
    ) {
      return true;
    }
    return false;
  }

  function syncCheckboxes() {
    document.querySelectorAll('[data-dd-preorder-acceptance-check]').forEach(function (cb) {
      cb.checked = accepted;
    });
  }

  function syncRows() {
    var required = isRequired();
    document.querySelectorAll('[data-dd-preorder-acceptance]').forEach(function (row) {
      if (required) {
        row.hidden = false;
        row.removeAttribute('hidden');
      } else {
        row.hidden = true;
        row.setAttribute('hidden', '');
        row.removeAttribute('open');
        row.classList.remove('is--open');
        if (row._ddDisclosureTimer) {
          clearTimeout(row._ddDisclosureTimer);
          row._ddDisclosureTimer = null;
        }
      }
    });
  }

  function syncDates() {
    var iso = currentIso();
    var pretty = '';
    if (iso && window.ddPreorder && typeof window.ddPreorder.prettyDay === 'function') {
      pretty = window.ddPreorder.prettyDay(iso);
    }
    document.querySelectorAll('[data-dd-preorder-acceptance-date]').forEach(function (el) {
      el.textContent = pretty || 'the ship date';
    });
  }

  function syncAcceptedProperty() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector('input[name="' + ACCEPTED_NAME + '"]');
    if (!isRequired() || !accepted) {
      if (input && input.parentNode) input.parentNode.removeChild(input);
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = ACCEPTED_NAME;
      form.appendChild(input);
    }
    input.value = '1';
  }

  function applyAtcFaces() {
    var blocked = atcBlocked();

    document.querySelectorAll('[data-dd-sf-atc]').forEach(function (btn) {
      if (btn.tagName === 'A' || btn.disabled) return;
      if (btn.classList.contains('is--availability-only')) return;
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is--custom-acceptance-required');
      } else if (btn.classList.contains('is--custom-acceptance-required')) {
        btn.classList.remove('is--custom-acceptance-required');
        btn.removeAttribute('aria-disabled');
      }
    });

    document.querySelectorAll('.product-form__submit.dd-atc-button').forEach(function (btn) {
      if (btn.disabled) return;
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is--custom-acceptance-required');
      } else if (btn.classList.contains('is--custom-acceptance-required')) {
        btn.classList.remove('is--custom-acceptance-required');
        if (!btn.classList.contains('loading')) {
          btn.removeAttribute('aria-disabled');
        }
      }
    });
  }

  function setAccepted(next) {
    accepted = !!next;
    syncCheckboxes();
    syncDisclosuresFromAccepted();
    syncAcceptedProperty();
    applyAtcFaces();
  }

  function refresh() {
    var required = isRequired();
    if (wasRequired && !required) {
      accepted = false;
    }
    wasRequired = required;
    syncRows();
    syncDates();
    syncCheckboxes();
    syncDisclosuresFromAccepted();
    syncAcceptedProperty();
    applyAtcFaces();
  }

  function expandStickyIfCollapsed() {
    var footer = document.querySelector('dd-sticky-footer');
    if (!footer) return;
    if (footer.classList.contains('is--collapsed')) {
      footer.classList.remove('is--collapsed');
      try {
        sessionStorage.setItem('dd_sticky_collapsed', 'false');
      } catch (e) { /* ignore */ }
    }
  }

  function isElementOnScreen(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.bottom > 0 && rect.top < vh;
  }

  function resolveAcceptanceRow(source) {
    var main = document.querySelector(
      '.dd-custom-acceptance--main[data-dd-preorder-acceptance]:not([hidden]), .product-form [data-dd-preorder-acceptance]:not([hidden])'
    );
    var sticky = document.querySelector(
      'dd-sticky-footer [data-dd-preorder-acceptance]:not([hidden])'
    );

    var prefer = null;
    if (source === 'main') prefer = 'main';
    else if (source === 'sticky') prefer = 'sticky';
    else if (source && source.nodeType === 1) {
      if (source.closest('dd-sticky-footer') || source.closest('[data-dd-sf-atc]')) {
        prefer = 'sticky';
      } else if (source.closest('product-form') || source.closest('.dd-block--buy-buttons')) {
        prefer = 'main';
      }
    }

    if (prefer === 'main' && main) return main;
    if (prefer === 'sticky' && sticky) return sticky;

    if (main && isElementOnScreen(main)) return main;
    if (sticky && isElementOnScreen(sticky)) return sticky;
    return main || sticky || null;
  }

  function shakeAndFocus(source) {
    var row = resolveAcceptanceRow(source);
    if (!row) return;

    if (row.closest('dd-sticky-footer')) {
      expandStickyIfCollapsed();
    }

    row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    row.classList.remove('is--shake');
    // eslint-disable-next-line no-unused-expressions
    row.offsetWidth;
    row.classList.add('is--shake');

    if (shakeTimer) clearTimeout(shakeTimer);
    shakeTimer = setTimeout(function () {
      row.classList.remove('is--shake');
    }, 950);

    var check = row.querySelector('[data-dd-preorder-acceptance-check]');
    if (check && typeof check.focus === 'function') {
      try {
        check.focus({ preventScroll: true });
      } catch (e) {
        check.focus();
      }
    }
  }

  function onDocClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.matches && t.matches('[data-dd-preorder-acceptance-check]')) {
      e.stopPropagation();
      e.preventDefault();
      setAccepted(!t.checked);
      return;
    }

    var wrap = t.closest('[data-dd-preorder-acceptance-check-wrap]');
    if (wrap) {
      e.stopPropagation();
      e.preventDefault();
      setAccepted(!accepted);
      return;
    }

    var summary = t.closest('.dd-custom-acceptance__summary');
    if (summary && summary.closest('[data-dd-preorder-acceptance]')) {
      e.preventDefault();
      setAccepted(!accepted);
    }
  }

  function onDocKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-dd-preorder-acceptance-check-wrap]')) return;
    if (t.matches && t.matches('[data-dd-preorder-acceptance-check]')) return;

    var summary = t.closest('.dd-custom-acceptance__summary');
    if (!summary || !summary.closest('[data-dd-preorder-acceptance]')) return;
    e.preventDefault();
    setAccepted(!accepted);
  }

  function onDocChange(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-dd-preorder-acceptance-check]')) return;
    setAccepted(!!t.checked);
  }

  function bind() {
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onDocKeydown, true);
    document.addEventListener('change', onDocChange);

    document.addEventListener('variantChange', function () {
      requestAnimationFrame(refresh);
    });
    document.addEventListener('dd:preorder-map-ready', function () {
      requestAnimationFrame(refresh);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initDisclosures();
        refresh();
      });
    } else {
      initDisclosures();
      refresh();
    }
    setTimeout(function () {
      initDisclosures();
      refresh();
    }, 0);
    setTimeout(refresh, 400);
  }

  window.ddPreorderGate = {
    isRequired: isRequired,
    isBlocked: isBlocked,
    setAccepted: setAccepted,
    refresh: refresh,
    applyAtcFaces: applyAtcFaces,
    shakeAndFocus: shakeAndFocus,
    initDisclosures: initDisclosures,
  };

  bind();
})();
